import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { BREAKPOINTS } from '../../../BeFi20.meta';
import { VisualPickerButtonContainer } from '../../../../CommonComponents/OPL/VisualPickerButton/VisualPickerButtonContainer';
import { KeyboardShortcut } from '../../Survey.styles';

export const Main = styled(motion.section)(({ theme }) => ({
  padding: '24px 16px 16px',
  position: 'absolute',
  width: '100%',
  background: 'none',
  boxSizing: 'border-box',
  top: 58,

  [`@media (min-width: ${BREAKPOINTS.sm})`]: {
    borderRadius: 12,
    boxShadow: theme.shadows['500'],
    width: 'min(90vw, 640px)',
    background: theme.colors.bg,
    padding: 32,
    margin: 'auto',
    height: 496,
    top: '50%',
    left: '50%',
  },
}));

export const VisualPicker = styled(VisualPickerButtonContainer)(({ theme }) => ({
  '&&:not(.disabled)[aria-pressed=true], &&:not(.disabled):active': {
    transition: 'all 0.2s ease',
    background: theme.colors.primary['500'],
    borderColor: theme.colors.primary['600'],
    color: theme.colors.white,

    [KeyboardShortcut]: {
      color: theme.colors.white,
    },
  },

  '&:not(.disabled):active&:not(.disabled):focus': {
    background: theme.colors.primary['500'],
  },

  [KeyboardShortcut]: {
    color: theme.colors.neutral['500'],
  },
}));

export const QuestionText = styled(Text)(({ theme }) => ({
  fontSize: theme.fontSizes.h4,
  fontWeight: 600,
  lineHeight: '32px',
  textAlign: 'center',
  marginBottom: 24,
  minHeight: 64,

  [`@media (min-width: ${BREAKPOINTS.sm})`]: {
    fontSize: theme.fontSizes.h3,
    lineHeight: '32px',
    minHeight: 96,
    marginTop: 24,
  },
}));

export const AnswerOptions = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
});
